(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulse-header"]) return;
  try {
    
  if (!customElements.get('pulse-menu')) {
    class PulseMenu extends HTMLElement {
      connectedCallback() {
        this.menu = this.querySelector('details');
        if (!this.menu) return;
        this.menu.addEventListener('click', (event) => {
          if (event.target.closest('.ph-menu__panel a')) this.menu.removeAttribute('open');
        });
        this.menu.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.menu.hasAttribute('open')) {
            this.menu.removeAttribute('open');
            const toggle = this.menu.querySelector('summary');
            if (toggle) toggle.focus();
          }
        });
      }
    }
    customElements.define('pulse-menu', PulseMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shaker-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shaker-landing')) {
    class ShakerLanding extends HTMLElement {
      connectedCallback() {
        this.initGallery();
        this.initSticky();
        this.initReveal();
        this.initDemo();
      }

      initDemo() {
        const video = this.querySelector('[data-sl-demo]');
        if (!video) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || !('IntersectionObserver' in window)) {
          video.controls = true;
          return;
        }
        this.demoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const played = video.play();
                if (played && played.catch) played.catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.4 }
        );
        this.demoObserver.observe(video);
      }

      initReveal() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
        const targets = this.querySelectorAll(
          '.sl-head, .sl-grid > li, .sl-feature, .sl-faq__item, .sl-cta, .sl-table-wrap'
        );
        this.setAttribute('data-sl-anim', '');
        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const node = entry.target;
              node.classList.add('is-in');
              this.revealObserver.unobserve(node);
              window.setTimeout(() => node.classList.remove('sl-reveal', 'is-in'), 1000);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
        );
        targets.forEach((node) => {
          const siblings = node.parentElement ? Array.from(node.parentElement.children) : [node];
          node.style.setProperty('--sl-i', Math.min(siblings.indexOf(node), 5));
          node.classList.add('sl-reveal');
          this.revealObserver.observe(node);
        });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.demoObserver) this.demoObserver.disconnect();
      }

      initGallery() {
        const stage = this.querySelector('[data-sl-stage]');
        if (!stage) return;
        const slides = stage.querySelectorAll('[data-sl-slide]');
        const prev = this.querySelector('[data-sl-prev]');
        const next = this.querySelector('[data-sl-next]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const current = () => Math.round(stage.scrollLeft / stage.clientWidth);
        const go = (index) => {
          const target = Math.max(0, Math.min(slides.length - 1, index));
          stage.scrollTo({ left: target * stage.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        };
        const sync = () => {
          const index = current();
          if (prev) prev.disabled = index <= 0;
          if (next) next.disabled = index >= slides.length - 1;
        };
        let timer = 0;
        stage.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(timer);
            timer = window.setTimeout(sync, 60);
          },
          { passive: true }
        );
        if (prev) prev.addEventListener('click', () => go(current() - 1));
        if (next) next.addEventListener('click', () => go(current() + 1));
        stage.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            go(current() + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            go(current() - 1);
          }
        });
        sync();
      }

      initSticky() {
        const bar = this.querySelector('[data-sl-sticky]');
        if (!bar || !('IntersectionObserver' in window)) return;
        const targets = Array.from(this.querySelectorAll('[data-sl-watch]'));
        const footer = document.querySelector('footer');
        if (footer) targets.push(footer);
        const visible = new Set();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              visible.add(entry.target);
            } else {
              visible.delete(entry.target);
            }
          });
          const show = visible.size === 0;
          bar.classList.toggle('is-visible', show);
          bar.toggleAttribute('inert', !show);
        });
        targets.forEach((target) => this.observer.observe(target));
      }
    }
    customElements.define('shaker-landing', ShakerLanding);
  }

  } catch(e) { console.error(e); }
})();
})();
